import {Component, Input} from "@angular/core";
import {CommonModule} from '@angular/common';
import {FieldOkItemComponent} from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './abteilungsub.list-view.html',
    styleUrls: ['./abteilungsub.list-view.scss']
})
export class AbteilungsubListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {}
}
